import React, { useState } from "react";
import AWS from "aws-sdk";

const S3_BUCKET = "opentext-public-use1-qa1"; //DTD--->  opentext-private-qa2
const REGION = "us-east-1";

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

const UploadImageToS3WithNativeSdk = () => {
  const [progress, setProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileInput = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const uploadFile = (file) => {
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: file.name,
    };

    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        setProgress(Math.round((evt.loaded / evt.total) * 100));
      })
      .send((err) => {
        if (err) {
          console.log(err);
        }
      });
  };

  // download file on clicking s3 url
  const key ="TFS-Assets/certificate/1/COA/COA_0027A_TestPartialSearch3_1.pdf";
  const downloadFile = () => {
    const params = {
      Bucket: S3_BUCKET,
      Key: key,
    };
  
    myBucket.getObject(params, (err, data) => {
      if (err) {
        console.error("Error downloading file:", err);
        return;
      }
  
      // Create a Blob from the file data
      const blob = new Blob([data.Body], { type: data.ContentType });
  
      // Create a URL for the Blob
      const url = window.URL.createObjectURL(blob);
  
      // Create a link element and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.download = key.split("/").pop(); // Use the file name from the key
      link.click();
  
      // Revoke the URL to free up memory
      window.URL.revokeObjectURL(url);
    });
  };
  return (
    <div style={{paddingTop:'100px'}}>
      <div>Native SDK File Upload Progress is {progress}%</div>
      <input type="file" onChange={handleFileInput} />
      <button onClick={() => uploadFile(selectedFile)}> Upload to S3</button>
      <button onClick={downloadFile} >Download File</button>
    </div>
  );
};

export default UploadImageToS3WithNativeSdk;